import { atom, selector } from "recoil";
import layoutStates from "../layout";

// This atom save mobile main Window size (video resolution)
export const mainWindowResolutionAtom = atom<{
  width: number;
  height: number;
}>({
  key: "mainWindowResolutionAtom",
  default: {
    width: null,
    height: null
  }
})

// This selector check if current main window height is greater then width on mobile
export const isMobileVideoTallerSelector = selector({
  key: "isMobileVideoTallerSelector",
  get({ get }) {
    const isMobileDevice = get(layoutStates.isMobileDevice)
    const { width, height } = get(mainWindowResolutionAtom)
    return isMobileDevice && width < height
  }
})
